function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import './scrollbar.scss';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import classNames from 'classnames';
import { useTheme } from '..';
const Scrollbar = _ref => {
  let {
    autoHeight,
    autoHeightMax,
    autoHide,
    thumbHeight,
    thumbWidth,
    thumbRadius,
    thumbColor,
    getNewDataPortion,
    isMobileView,
    positionFromStartFetchNewDataPortion,
    viewClassName,
    ...rest
  } = _ref;
  const {
    theme
  } = useTheme();
  const handleScroll = e => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight
    } = e;
    // position will be greater than 1 if we are about to reach the bottom
    const position = (scrollTop + positionFromStartFetchNewDataPortion) / (scrollHeight - clientHeight);
    if (position > 1) getNewDataPortion();
  };
  const renderThumbVertical = _ref2 => {
    let {
      style,
      ...props
    } = _ref2;
    const thumbStyle = {
      backgroundColor: thumbColor,
      width: thumbWidth,
      zIndex: '10',
      borderRadius: thumbRadius
    };
    return /*#__PURE__*/React.createElement("div", _extends({
      className: "track",
      style: {
        ...style,
        ...thumbStyle
      }
    }, props));
  };
  const renderView = _ref3 => {
    let {
      style,
      ...props
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", _extends({
      className: classNames('box', viewClassName),
      style: {
        ...style,
        overflowX: 'hidden',
        marginBottom: 0
      }
    }, props));
  };
  return /*#__PURE__*/React.createElement(Scrollbars, _extends({
    onUpdate: getNewDataPortion && handleScroll,
    className: classNames('custom-scrollbars', {
      'custom-scrollbars-hide': autoHide
    }),
    renderView: renderView,
    renderThumbVertical: renderThumbVertical,
    renderThumbHorizontal: props => /*#__PURE__*/React.createElement("div", _extends({}, props, {
      className: "thumb-horizontal"
    })),
    autoHeight: autoHeight,
    autoHeightMax: autoHeightMax,
    thumbSize: thumbHeight
  }, rest));
};
Scrollbar.defaultProps = {
  autoHeight: true,
  autoHeightMax: '100vh',
  autoHide: false,
  thumbColor: '#E5E5E5',
  thumbHeight: 200,
  thumbRadius: 8,
  thumbWidth: 8,
  positionFromStartFetchNewDataPortion: 10
};
Scrollbar.propTypes = {
  autoHeight: PropTypes.bool,
  autoHide: PropTypes.bool,
  thumbColor: PropTypes.string,
  thumbHeight: PropTypes.number,
  thumbRadius: PropTypes.number,
  thumbWidth: PropTypes.number
};
export default /*#__PURE__*/memo(Scrollbar);